module.exports = __webpack_public_path__ + "static/media/close.eb07092d.svg";